export default __webpack_public_path__ + "static/media/settings.8afbce8f.svg";